export default {
    baseStyle: {
        recipeContainer: {
            flexDir: 'column',
            gap: {
                base: 'small.base',
                lg: 'small.lg',
            },
            w: '100%',
            h: 'auto',
            marginBottom: {
                base: 'medium.base',
                sm: 'medium.base',
                md: 'unset',
                lg: 'unset',
            },
        },
        imageContainer: {
            width: '100%',
            overflow: 'hidden',
        },
        imageObject: {
            width: '100%',
            height: '100%',
            aspectRatio: '1',
            objectFit: 'cover',
        },
        textsContainer: {
            flexDir: 'column',
            alignItems: 'flex-start',
            gap: {
                base: 'small.base',
                lg: 'small.lg',
            },
        },
        descriptionText: {
            color: 'text.default',
            textStyle: 'body-small',
            fontWeight: 'light',
        },
        extraContainer: {
            justifyContent: 'flex-start',
            gap: {
                base: 'small.base',
                lg: 'small.lg',
            },
        },
        titleText: {
            color: 'text.default',
            textStyle: 'head-xsmall',
            fontWeight: 'semibold',
        },
        iconConfig: {
            w: {
                base: 'iconsSize.small',
                lg: 'iconsSize.medium',
            },
            h: {
                base: 'iconsSize.small',
                lg: 'iconsSize.medium',
            },
            flexShrink: 0,
        },
        infoContainer: {
            gap: {
                base: 'xxsmall.base',
                lg: 'xxsmall.lg',
            },
            alignItems: 'center',
            justifyContent: 'center',
        },
        infoText: {
            color: 'text.default',
            textStyle: 'body-small',
            fontWeight: 'light',
        },
    },
}
